<template>
    <div class="modal fade" :class="{ 'is-open': open }">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">編輯保障設定</h3>
                </div>
                <div class="modal-body">
                    <form class="form">
                        <div class="row">
                            <div v-for="(level, index) in parents" :key="index" class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-right pr-0" for="">保障階層第{{ index+1 }}層：</label>
                                    <label class="col-9 text-thin" for="">{{ level.code }} {{ level.category }}</label>
                                </div>
                            </div>
                            <!-- 保障中項 -->
                            <div v-if="open" class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-right pr-0" for="">中項保障群組：</label>
                                    <div class="col-8">
                                        <report-setting-coverage-select :value="coverageData" />
                                    </div>
                                </div>
                            </div>
                            <!-- 特殊條件 -->
                            <div v-if="open && detailData.code" class="col-12">
                                <div class="form-group row">
                                    <label class="col-3 text-right pr-0" for="">關聯特殊條件：</label>
                                    <div class="col-8">
                                        <report-setting-coverage-select isdetail :value="detailData" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <a @click="$emit('close')" class="btn btn-default">取消</a>
                    <a @click="doConfirm()" class="btn btn-primary">確認</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ReportSettingCoverageSelect from './ReportSettingCoverageSelect.vue';

export default {
    name: "ReportSettingCoverageEditModal",
    components: { ReportSettingCoverageSelect },
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            required: true, 
            default: () => []
        }
    },
    data() {
        return {
            parents: [],
            coverageData: {},
            detailData: {},
        }
    },
    watch: {
        open: "initData",
    },
    methods: {
        initData() {
            let coverage = this.data[this.data.length-1]
            this.coverageData = {
                code: coverage.coverage,
                codename: coverage.coveragename,
            }
            this.detailData = {
                code: coverage.detail,
                codename: coverage.detailname,
            }
            this.parents = this.data.slice(0, this.data.length-1);
        },
        doConfirm() {
            this.$emit("confirm", this.data, this.coverageData, this.detailData);
        },
    },
};
</script>

<style scoped>
.modal.fade .modal-body {
    min-height: auto;
}
</style>